import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonLineOfCredit } from './ObjectiveTypeBaseReasonLineOfCredit.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';
import {
  ObjectivePaymentPlanOption,
  objectivePaymentPlanOptions
} from './ObjectivePaymentPlanOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  const availableObjectivePaymentPlanOptions = without(
    objectivePaymentPlanOptions,
    ObjectivePaymentPlanOption.none.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(Joi, availableImportantOptions, labeled(label, 'Line of credit'))
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          planForPayingLineOfCredit: enumRequired(
            Joi,
            availableObjectivePaymentPlanOptions,
            labeled(
              label,
              "What is the applicant's plan for paying off the line of credit at the end of or during the term?"
            )
          ),
          reason: objectiveTypeBaseReasonLineOfCredit(
            Joi,
            labeled(label, 'Why is flexibility of drawdown and repayments important? - ')
          )
        })
      }
    );
};

export default {
  schema
};
